__turbopack_context__.v({
  "selectNative": "select-native-module-scss-module__MVt_6G__selectNative",
  "selectNative__hideBorder": "select-native-module-scss-module__MVt_6G__selectNative__hideBorder",
  "selectNative_arrow": "select-native-module-scss-module__MVt_6G__selectNative_arrow",
  "selectNative_select": "select-native-module-scss-module__MVt_6G__selectNative_select",
  "selectNative_select__hideBorder": "select-native-module-scss-module__MVt_6G__selectNative_select__hideBorder",
  "selectNative_select__isError": "select-native-module-scss-module__MVt_6G__selectNative_select__isError",
  "selectNative_select__size-md": "select-native-module-scss-module__MVt_6G__selectNative_select__size-md",
  "selectNative_select__size-sm": "select-native-module-scss-module__MVt_6G__selectNative_select__size-sm",
});
